/**
 * A Settings tab that has no page yet.
 *
 * NO HEADER AND NO BACK ARROW OF ITS OWN. The surface's band titles Settings on
 * every route and the workspace above titles the workspace; a third heading and
 * a second arrow here were the page's whole contribution to the stack of back
 * affordances desktop was carrying. Same shape as the Safety tab pages.
 *
 * It still says WHICH tab it is, because with one visible tab a workspace draws
 * no strip (Activity), and "Coming soon" under a heading reading "Activity"
 * does not tell the reader that the Audit Log is the thing that is coming.
 */
export default function SettingsPlaceholder({ title }: { title: string }) {
  return (
    <div className="px-6 py-12 text-center">
      <h2 className="text-sm font-semibold text-fieldiq-text">{title}</h2>
      <p className="mt-1 text-sm text-fieldiq-muted">Coming soon</p>
    </div>
  );
}
